module.exports = __webpack_public_path__ + "img/speak1.ff0f9438.png";